const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cc77dc4ef91c1cfc81f0d9eff16e27fab204d7b0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend@sproutl"]={id:"cc77dc4ef91c1cfc81f0d9eff16e27fab204d7b0"};
      